<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option v-for="item in optionList" :label="item.desc" :value="item.value" :key="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'filter-account-status',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      optionList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  created() {
    this.getOptionList()
  },

  methods: {
    getOptionList() {
      if (this.optionList.length > 0) return
      this.fetch
        .get('staffGetAccountStatus')
        .then((res) => {
          this.optionList = res.data || []
          if (this.required && this.optionList[0]) {
            this.selectedValue = this.optionList[0]['value']
          }
        })
        .catch(() => {})
    },
  },
}
</script>
